import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Button } from "../../../components/buttons/button";
import { CopyButton } from "../../../components/buttons/copyButton";
import { InfoCard } from "../../../components/cards/infoCard";
import { Pill } from "../../../components/pill";
import { BgWrapper } from "../../../components/wrapper/bgWrapper";
import { getEventUrl } from "../../../utils/helpers";

export const EventPublishedPage = () => {
  const [eventUrl, setEventUrl] = useState("");

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const { slug } = useParams();

  useEffect(() => {
    if (!slug) {
      navigate("/home");
    }

    setEventUrl(getEventUrl(slug!));
    // eslint-disable-next-line
  }, []);

  return (
    <div className="flex w-full justify-center">
      <div className="mx-auto flex w-full max-w-[500px] flex-col gap-3">
        <BgWrapper className="flex w-full flex-col items-center justify-center gap-4 !py-10">
          <img
            alt="calendar"
            src="/assets/images/party-popper-glass.png"
            className="h-[120px] w-[120px]"
          />

          <Pill variation="green" text="PUBLISHED" />

          <div className="mx-auto w-full max-w-[320px] text-center">
            <p className="text-32 font-fraunces font-medium text-primary">
              {searchParams.get("eventName") ?? "Your event"} is live! ⚡️
            </p>
            <p className="mt-2 text-grey-600">
              Your event has been published. Promote your event to boost your
              ticket sales{" "}
            </p>
          </div>

          <Button
            type="button"
            onClick={() => {
              navigate(`/events/${encodeURIComponent(slug ?? "")}/details`, {
                replace: true,
              });
            }}
            text="View Event Details"
            className="!max-w-fit"
          />
        </BgWrapper>

        <BgWrapper>
          <p className="mt-2 font-bold text-grey-500">📢 Share your event!</p>
          <p className="mt-1 text-sm text-grey-900">
            Share links to your upcoming events on social media! It keeps your
            followers informed and helps attract more attendees.{" "}
          </p>

          <div className="mt-3 flex w-full items-center justify-between gap-4 rounded-[100px] bg-grey-50 p-4 text-sm font-bold text-grey-950">
            <p className="line-clamp-1 max-w-full flex-1 overflow-hidden text-ellipsis">
              {eventUrl}
            </p>

            <CopyButton value={eventUrl} />
          </div>
        </BgWrapper>

        <InfoCard
          title="Create as many events as you want with Tikket"
          text="We only charge for paid tickets and we pay out the next day!"
          leftIcon="party-popper"
          leftClassName="text-success"
        />
      </div>
    </div>
  );
};
